import {constractMapUrl} from "@/libs/helper";
import {getFuelEventType} from "./fuelStatus";

const isFuelEventType = (data: any, eventType: number) =>
  getFuelEventType(data?.type) === eventType;

const getFuelLocationValue = (data: any) => {
  const location = data?.location;

  if (Array.isArray(location)) {
    return location.filter(Boolean).join(", ");
  }

  if (location) {
    return String(location).trim();
  }

  const latitude = data?.latitude ?? data?.lat;
  const longitude = data?.longitude ?? data?.lng ?? data?.lon;

  if (latitude != null && longitude != null) {
    return `${latitude},${longitude}`;
  }

  return "";
};

export const formatFuelLocation = (data: any) => {
  if (!isFuelEventType(data, 3)) {
    return "";
  }

  return getFuelLocationValue(data);
};

const hasFuelCoordinatePair = (latitude: string, longitude: string) =>
  latitude !== "" &&
  longitude !== "" &&
  Number.isFinite(Number(latitude)) &&
  Number.isFinite(Number(longitude));

export const NeoFuelLocation: React.FC<any> = ({data}) => {
  const location = formatFuelLocation(data);
  if (location === "") {
    return <>{location}</>;
  }

  const [latitude, longitude] = location
    .split(",")
    .map((coordinate: string) => coordinate.trim());

  if (!hasFuelCoordinatePair(latitude, longitude)) {
    return <>{location}</>;
  }

  return (
    <a
      href={constractMapUrl(latitude, longitude)}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-800"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M8 1.333c-2.58 0-4.667 2.087-4.667 4.667 0 3.5 4.667 8.667 4.667 8.667S12.667 9.5 12.667 6c0-2.58-2.087-4.667-4.667-4.667Zm0 6.334A1.667 1.667 0 1 1 8 4.333a1.667 1.667 0 0 1 0 3.334Z"
          fill="currentColor"
        />
      </svg>
      View Location
    </a>
  );
};
